export const BreadcrumbType = {
  nonClickable: "nonClickable",
  lang: "lang",
  folder: "folder",
  book: "book",
  chapter: "chapter",
  externalUrl: "externalUrl",
};
